'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getRandom = function () { return Math.floor(Math.random() * 1000); };
var getUniqueKey = function (infix, index) {
    return "grid-".concat(infix, "-").concat(index, "-").concat(getRandom());
};

exports.getUniqueKey = getUniqueKey;
//# sourceMappingURL=utils.js.map
